module.exports = __webpack_public_path__ + "img/icon_nextpage.5e3d5bf6.png";